module.exports = __webpack_public_path__ + "img/scoredIconFocus.ae202031.png";